import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose, AiOutlineSend } from "react-icons/ai";
import { MdOutlineScheduleSend } from "react-icons/md";
import { useAuth } from "../../../../Contexts/AuthContext/AuthContext";
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { baseUrl } from "../../../../Environments/environment";
import { useSocket } from "../../../../Contexts/SocketContext/SocketContext";
import { Input } from "@headlessui/react";
import { toast } from "react-toastify";
import { AiOutlineArrowLeft } from "react-icons/ai";
import checkIn from "../../../../Assets/Checkin.svg";
import checkOut from "../../../../Assets/Checkout.svg";
import { apiClient } from "../../../../api";
import EditGuestModal from "../../../EditGuestModal/EditGuestModal";

// const useReactQuerySubscription = (socket, propertyId, guestId) => {
//   const queryClient = useQueryClient();
//   useEffect(() => {
//     if (socket) {
//       const updateMessages = () => {
//         queryClient.invalidateQueries(["messages", propertyId, guestId]);
//       };
//       socket.on("message:newMessage", updateMessages);
//       return () => {
//         socket.off("message:newMessage", updateMessages);
//       };
//     }
//   }, [socket, queryClient, propertyId, guestId]);
// };

const sendMessage = async (propertyId, guestId, message, accessToken) => {
	const response = await apiClient.post(
		`${baseUrl}/sms/send/${propertyId}/${guestId}/`,
		message,
	);
	if (response.ok) {
		const newToken = response.headers.get("Authorization");
		if (newToken) {
			localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
		}
	}
	return response.data.result;
};

const useChatScroll = (dep) => {
	const ref = useRef();
	useEffect(() => {
		if (ref.current) {
			ref.current.scrollTop = ref.current.scrollHeight;
		}
	}, [dep]);
	return ref;
};

const ChatScreenModal = ({ onClose, guestId, guest, closeChatModal }) => {
	const { accessToken } = useAuth();
	const { selectedPropertyId } = useProperty();
	const { socket } = useSocket();
	const [guestMessages, setGuestMessages] = useState([]);
	const [isAddOnLoading, setIsAddOnLoading] = useState({
		loading: false,
		id: "",
	});
	const [isHouseKeepingAddOnLoading, setIsHouseKeepingAddOnLoading] = useState({
		loading: false,
		id: "",
	});
	const [isCustomAddOnLoading, setIsCustomAddOnLoading] = useState({
		loading: false,
		id: "",
	});
	const [isDndmodeRequestLoading, setIsDndmodeRequestLoading] = useState({
		loading: false,
		id: "",
	});

	const [isSending, setIsSending] = useState(false);
	const [messagesLoading, setMessagesLoading] = useState(false);
	const [isEditGuestModalOpen, setIsEditGuestModalOpen] = useState(false);
	const fetchMessages = async (baseUrl, propertyId, guestId, accessToken) => {
		try {
			const response = await apiClient.get(
				`${baseUrl}/message/${propertyId}/${guestId}`,
			);
			setTimeout(() => {
				apiClient
					.put(
						`${baseUrl}/chatList/${propertyId}/${guestId}/resetUnreadMessages`,
						{
							unreadMessages: 0,
						},
					)
					.catch((error) => {
						console.log(error);
					});
			}, 1000);

			setGuestMessages(response.data.result.messages);
			return response.data.result.messages;
		} catch (error) {
			toast.error(error.response?.data?.message || "Failed to fetch messages");
		}
	};
	useEffect(() => {
		socket.emit("message:joinRoom", {
			propertyId: selectedPropertyId,
			guestId: guestId,
		});
		const fetchGuestMessages = async () => {
			setMessagesLoading(true);
			await fetchMessages(baseUrl, selectedPropertyId, guestId, accessToken);
			setMessagesLoading(false);
		};
		fetchGuestMessages();
		socket.on("message:newMessage", (msg) => {
			setGuestMessages((prevMessages) => [...prevMessages, msg]);
		});
	}, [selectedPropertyId, guestId, socket]);

	//useReactQuerySubscription(socket, selectedPropertyId, guestId);

	const {
		data: messages = [],
		isLoading,
		error,
	} = useQuery({
		queryKey: ["messages", selectedPropertyId, guestId],
		queryFn: () =>
			fetchMessages(baseUrl, selectedPropertyId, guestId, accessToken),
		staleTime: 0,
		cacheTime: 0,
	});

	const queryClient = useQueryClient();

	// Use Mutation
	const [newMessage, setNewMessage] = useState("");

	// const mutation = useMutation({
	//   mutationFn: ({ propertyId, guestId, message }) =>
	//     sendMessage(propertyId, guestId, message, accessToken),
	//   onSuccess: () => {
	//     queryClient.invalidateQueries(["messages", selectedPropertyId, guestId]);
	//     setNewMessage("");
	//   },
	//   onError: (error) => {
	//     toast.error(error.response.data.message);
	//   },
	// });

	// const handleSendMessage = () => {
	//   if (newMessage.trim()) {
	//     mutation.mutate({
	//       propertyId: selectedPropertyId,
	//       guestId,
	//       message: { body: newMessage },
	//     });
	//   }
	// };
	const handleSendMessage = async () => {
		if (newMessage.trim()) {
			try {
				setIsSending(true);
				await sendMessage(
					selectedPropertyId,
					guestId,
					{ body: newMessage },
					accessToken,
				);

				//setMessagesLoading(true);
				// Optionally, you can fetch the updated messages here
				await fetchMessages(baseUrl, selectedPropertyId, guestId, accessToken);
			} catch (error) {
				toast.error(error.response?.data?.message || "Failed to send message");
			} finally {
				setNewMessage("");
				setIsSending(false);
				//setMessagesLoading(false);
			}
		}
	};
	const scrollRef = useChatScroll(guestMessages);

	const handleStatusChange = async (status, message) => {
		const url = `${baseUrl}/checkInOutRequest/${message.propertyId}/${message.guestId}/${message.request._id}`;
		// setRequestStatus(status);
		let updatedStatus = {
			requestStatus: status,
		};

		try {
			setIsAddOnLoading({ ...isAddOnLoading, loading: true });
			const response = await apiClient.patch(url, updatedStatus);

			setIsAddOnLoading({ ...isAddOnLoading, loading: false });
			toast.success(`Status updated to ${status}`);
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update status. Please try again.";
			toast.error(errorMessage);
			setIsAddOnLoading({ ...isAddOnLoading, loading: false });
		}
	};
	const handleHouseKeepingStatusChange = async (status, message) => {
		const url = `${baseUrl}/guest/houseKeepingRequest/${message.propertyId}/${message.guestId}/${message.houseKeepingRequest[0]._id}`;
		// setRequestStatus(status);
		let updatedStatus = {
			requestStatus: status,
		};
		try {
			setIsHouseKeepingAddOnLoading({
				...isHouseKeepingAddOnLoading,
				loading: true,
			});
			const response = await apiClient.patch(url, updatedStatus);

			toast.success(`Status updated to ${status}`);
			setIsHouseKeepingAddOnLoading({
				...isHouseKeepingAddOnLoading,
				loading: false,
			});
			const fetchGuestMessages = async () => {
				// setMessagesLoading(true);
				await fetchMessages(baseUrl, selectedPropertyId, guestId, accessToken);
				// setMessagesLoading(false);
			};
			fetchGuestMessages();
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update status. Please try again.";
			toast.error(errorMessage);
			setIsHouseKeepingAddOnLoading({
				...isHouseKeepingAddOnLoading,
				loading: false,
			});
		}
	};
	const handleCustomAddonStatusChange = async (status, message) => {
		const url = `${baseUrl}/addOnsRequest/${message.propertyId}/${message.guestId}/${message.addOnsRequest[0]._id}`;
		// setRequestStatus(status);
		let updatedStatus = {
			requestStatus: status,
		};
		try {
			setIsCustomAddOnLoading({
				...isCustomAddOnLoading,
				loading: true,
			});
			const response = await apiClient.put(url, updatedStatus);

			toast.success(`Status updated to ${status}`);
			setIsCustomAddOnLoading({
				...isCustomAddOnLoading,
				loading: false,
			});
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update status. Please try again.";
			toast.error(errorMessage);
			setIsCustomAddOnLoading({
				...isCustomAddOnLoading,
				loading: false,
			});
		}
	};
	const handleDndModeRequestStatusChange = async (status, message) => {
		const url = `${baseUrl}/dndmodeRequest/${message.propertyId}/${message.guestId}/${message.donotdisturbRequest[0]._id}`;
		// setRequestStatus(status);
		let updatedStatus = {
			requestStatus: status,
		};
		try {
			setIsDndmodeRequestLoading({
				...isDndmodeRequestLoading,
				loading: true,
			});
			const response = await apiClient.put(url, updatedStatus);
			if (response.ok) {
				const newToken = response.headers.get("Authorization");
				if (newToken) {
					localStorage.setItem("accessToken", newToken.split(" ")[1]); // Save the new token
				}
			}
			toast.success(`Status updated to ${status}`);
			setIsDndmodeRequestLoading({
				...isDndmodeRequestLoading,
				loading: false,
			});
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				"Failed to update status. Please try again.";
			toast.error(errorMessage);
			setIsDndmodeRequestLoading({
				...isDndmodeRequestLoading,
				loading: false,
			});
		}
	};

	const handleOutsideClick = (e) => {
		if (e.target === e.currentTarget) {
			// Check if onClose function is defined before calling it
			if (typeof onClose === "function") {
				onClose();
			}

			// Optionally, call closeChatModal if it's part of your codebase
			if (typeof closeChatModal === "function") {
				closeChatModal();
			}
		}
	};

	const handleEditGuestSuccess = () => {
		setIsEditGuestModalOpen(false);
		if (typeof onClose === "function") {
			onClose();
		}
		if (typeof closeChatModal === "function") {
			closeChatModal();
		}
	};
	console.log("guest", guest);
	console.log(new Date(guest.checkOut) > new Date());

	return (
		<div
			className="fixed inset-0 flex items-end justify-end z-50"
			onClick={handleOutsideClick}
		>
			<div
				className="bg-white p-0 rounded-xl rounded-t-2xl shadow-lg max-w-md w-[30vw] min-w-[350px] m-4  relative"
				onClick={(e) => e.stopPropagation()}
			>
				<div className={`p-4 rounded-t-xl border-b border-gray-200`}>
					<div className="flex items-center justify-between">
						<div className="flex items-center space-x-1">
							<button
								onClick={onClose}
								className="text-indigo-700 border bg-white h-10 w-10 flex items-center justify-center rounded-xl focus:outline-none"
							>
								<AiOutlineArrowLeft className="h-5 w-5" />
							</button>

							<div
								className="cursor-pointer"
								onClick={() => setIsEditGuestModalOpen(true)}
							>
								<div className="flex items-center space-x-2">
									<h2 className="text-gray-800 font-medium">
										{guest.firstName} {guest.lastName}
									</h2>
									<p className="text-sm text-gray-500">
										{guest.countryCode} {guest.phoneNumber}
									</p>
									<p className="text-sm text-[#065F46] bg-[#D1FAE5] rounded-full px-3">
										{guest.roomNumber}
									</p>
								</div>
								<div className="flex space-x-4 text-xs text-gray-500 mt-2">
									<div className="flex items-center space-x-2">
										<img src={checkIn} alt="Check-in" className="h-4 w-4" />
										<p>
											{guest.checkIn
												? new Date(guest.checkIn).toLocaleString("en", {
														year: "numeric",
														month: "2-digit",
														day: "2-digit",
														hour: "2-digit",
														minute: "2-digit",
														hour12: true,
														timeZone: "UTC",
													})
												: ""}
										</p>
									</div>
									<div className="flex items-center space-x-2">
										<img
											src={checkOut}
											alt="Check-out"
											className="h-3.5 w-3.5"
										/>
										<p>
											{guest.checkOut
												? new Date(guest.checkOut).toLocaleString("en", {
														year: "numeric",
														month: "2-digit",
														day: "2-digit",
														hour: "2-digit",
														minute: "2-digit",
														hour12: true,
														timeZone: "UTC",
													})
												: ""}
										</p>
									</div>
								</div>
							</div>
						</div>

						{/* <button
              onClick={onClose}
              className="text-gray-700 hover:text-gray-900 focus:outline-none"
            >
              <AiOutlineClose className="h-5 w-5" />
            </button> */}
					</div>
				</div>

				<div className="p-4 h-[60vh] overflow-y-scroll" ref={scrollRef}>
					{isLoading || messagesLoading ? (
						// <LoadingSpinner />
						<p>Loading</p>
					) : error ? (
						<div className="text-red-500">Failed to load messages</div>
					) : (
						<ul className="space-y-1">
							{guestMessages.map((message) => (
								<li
									key={message._id}
									className={`${
										message.senderId === message.guestId
											? "text-left"
											: "text-right"
									}`}
								>
									{message.messageType === "Request" && message.request && (
										<div
											className={`inline-block text-sm p-4 ${
												message.request.requestStatus === "Accepted" ||
												message.request.requestStatus === "Declined"
													? "bg-gray-200"
													: "bg-yellow-100"
											} text-gray-800 rounded-xl max-w-[300px] shadow-sm mb-2`}
										>
											<div className="mb-2">
												{message.content} for{" "}
												{message.request.earlyCheckInDateTime
													? new Date(
															message.request.earlyCheckInDateTime,
														).toLocaleString("en", {
															day: "2-digit",
															month: "2-digit",
															hour: "2-digit",
															minute: "2-digit",
															hour12: true,
															timeZone: "UTC",
														})
													: message.request.lateCheckOutDateTime
														? new Date(
																message.request.lateCheckOutDateTime,
															).toLocaleString("en", {
																day: "2-digit",
																month: "2-digit",
																hour: "2-digit",
																minute: "2-digit",
																hour12: true,

																timeZone: "UTC",
															})
														: new Date(
																message.request.extendStayDateTime,
															).toLocaleString("en", {
																year: "numeric",
																day: "2-digit",
																month: "2-digit",
																// hour: "2-digit",
																// minute: "2-digit",
																// hour12: true,
																timeZone: "UTC",
															})}
											</div>
											{message.request.requestStatus === "Accepted" ||
											message.request.requestStatus === "Declined" ? (
												<div
													className={`text-right text-sm ${
														message.request.requestStatus === "Accepted"
															? "text-green-600"
															: message.request.requestStatus === "Declined"
																? "text-red-600"
																: "text-gray-600"
													}`}
												>
													{message.request.requestStatus}
												</div>
											) : (
												<div className="flex justify-end space-x-2">
													{isAddOnLoading.id == message._id &&
													isAddOnLoading.loading ? (
														<p>Please wait...</p>
													) : (
														<>
															<button
																className="text-red-500 px-1 py-1 text-sm rounded-md hover:red-600 transition disabled:opacity-50"
																onClick={() => {
																	handleStatusChange("Declined", message);
																	setIsAddOnLoading({
																		loading: true,
																		id: message._id,
																	});
																}}
																disabled={
																	guest?.status?.currentStatus === "Checked Out"
																}
															>
																{isAddOnLoading.id == message._id &&
																isAddOnLoading.loading
																	? "Please Wait..."
																	: "Deny"}
															</button>
															<button
																className="bg-green-400 text-white px-3 py-1 text-sm rounded-full hover:bg-green-500 transition disabled:opacity-50"
																onClick={() => {
																	handleStatusChange("Accepted", message);
																	setIsAddOnLoading({
																		loading: true,
																		id: message._id,
																	});
																}}
																disabled={
																	guest?.status?.currentStatus === "Checked Out"
																}
															>
																{isAddOnLoading.id == message._id &&
																isAddOnLoading.loading
																	? "Please Wait..."
																	: "Accept"}
															</button>
														</>
													)}
												</div>
											)}
										</div>
									)}
									{message.messageType === "Addons Request" &&
										message.addOnsRequest[0] && (
											<div
												className={`inline-block text-sm p-4 ${
													message.addOnsRequest[0].requestStatus ===
														"Accepted" ||
													message.addOnsRequest[0].requestStatus === "Declined"
														? "bg-gray-200"
														: "bg-yellow-100"
												} text-gray-800 rounded-xl max-w-[300px] shadow-sm mb-2`}
											>
												<div className="mb-2">{message.content}</div>
												{message.addOnsRequest[0].requestStatus ===
													"Accepted" ||
												message.addOnsRequest[0].requestStatus ===
													"Declined" ? (
													<div
														className={`text-right text-sm ${
															message.addOnsRequest[0].requestStatus ===
															"Accepted"
																? "text-green-600"
																: message.addOnsRequest[0].requestStatus ===
																		"Declined"
																	? "text-red-600"
																	: "text-gray-600"
														}`}
													>
														{message.addOnsRequest[0].requestStatus}
													</div>
												) : (
													<div className="flex justify-end space-x-2">
														{isCustomAddOnLoading.id == message._id &&
														isCustomAddOnLoading.loading ? (
															<p>Please wait...</p>
														) : (
															<>
																<button
																	className="text-red-500 px-1 py-1 text-sm rounded-md hover:red-600 transition disabled:opacity-50"
																	onClick={() => {
																		handleCustomAddonStatusChange(
																			"Declined",
																			message,
																		);
																		setIsCustomAddOnLoading({
																			loading: true,
																			id: message._id,
																		});
																	}}
																	disabled={
																		guest?.status?.currentStatus ===
																		"Checked Out"
																	}
																>
																	Deny
																</button>
																<button
																	className="bg-green-400 text-white px-3 py-1 text-sm rounded-full hover:bg-green-500 transition disabled:opacity-50 disabled:hover:bg-green-400"
																	onClick={() => {
																		handleCustomAddonStatusChange(
																			"Accepted",
																			message,
																		);
																		setIsCustomAddOnLoading({
																			loading: true,
																			id: message._id,
																		});
																	}}
																	disabled={
																		guest?.status?.currentStatus ===
																		"Checked Out"
																	}
																>
																	Accept
																</button>
															</>
														)}
													</div>
												)}
											</div>
										)}{" "}
									{message.messageType === "Do not Disturb mode Request" &&
										message.donotdisturbRequest[0] && (
											<>
												<div
													className={`inline-block text-sm p-4 ${
														message.donotdisturbRequest[0].requestStatus ===
															"Accepted" ||
														message.donotdisturbRequest[0].requestStatus ===
															"Declined"
															? "bg-gray-200"
															: "bg-yellow-100"
													} text-gray-800 rounded-xl max-w-[300px] shadow-sm mb-2`}
												>
													<div className="mb-2">{message.content}</div>
													{message.donotdisturbRequest[0].requestStatus ===
														"Accepted" ||
													message.donotdisturbRequest[0].requestStatus ===
														"Declined" ? (
														<div
															className={`text-right text-sm ${
																message.donotdisturbRequest[0].requestStatus ===
																"Accepted"
																	? "text-green-600"
																	: message.donotdisturbRequest[0]
																				.requestStatus === "Declined"
																		? "text-red-600"
																		: "text-gray-600"
															}`}
														>
															{message.donotdisturbRequest[0].requestStatus}
														</div>
													) : (
														<div className="flex justify-end space-x-2">
															{isDndmodeRequestLoading.id === message._id &&
															isDndmodeRequestLoading.loading ? (
																<p>Please wait...</p>
															) : (
																<>
																	<button
																		className="text-red-500 px-1 py-1 text-sm rounded-md hover:red-600 transition"
																		onClick={() => {
																			handleDndModeRequestStatusChange(
																				"Declined",
																				message,
																			);
																			setIsDndmodeRequestLoading({
																				loading: true,
																				id: message._id,
																			});
																		}}
																	>
																		Deny
																	</button>
																	<button
																		className="bg-green-400 text-white px-3 py-1 text-sm rounded-full hover:bg-green-500 transition disabled:opacity-50"
																		onClick={() => {
																			handleDndModeRequestStatusChange(
																				"Accepted",
																				message,
																			);
																			setIsDndmodeRequestLoading({
																				loading: true,
																				id: message._id,
																			});
																		}}
																		disabled={
																			guest?.status?.currentStatus !==
																			"In House"
																		}
																	>
																		Accept
																	</button>
																</>
															)}
														</div>
													)}
												</div>
											</>
										)}{" "}
									{message.messageType === "SMS" && (
										<>
											<div
												className={`inline-block px-4 p-2 text-sm max-w-[300px] w-auto break-words ${
													message.senderId === message.guestId
														? "bg-gray-100 text-gray-700 rounded-b-3xl rounded-r-3xl text-start"
														: "bg-indigo-600 text-gray-100 rounded-bl-3xl rounded-t-3xl text-start"
												}`}
											>
												{message.content}
											</div>
											{/**<div className="text-gray-500 mt-1 text-xs text-[0.75em]">
                        {new Date(message.createdAt).toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                          year: "numeric",
                          day: "2-digit",
                          month: "2-digit",
                        })}
                      </div> */}
										</>
									)}
									{message.messageType === "Review Reply" &&
										(() => {
											let reviewText = "";
											let replyText = "";

											try {
												const partsAfterReview = message.content.split(
													"Hello! Thank you for your review: ",
												);
												if (partsAfterReview.length > 1) {
													const parts = partsAfterReview[1].split(
														"\nOur team has seen it and replied: ",
													);
													reviewText = parts[0];
													if (parts[1]) {
														// Remove the trailing part after the actual reply
														replyText = parts[1].split(
															"\nWe appreciate your feedback and are always here to help!",
														)[0];
													}
												}
											} catch (err) {
												console.error("Error parsing message content", err);
											}
											return (
												<>
													<div
														className={`inline-block px-4 p-2 text-sm max-w-[300px] w-auto break-words bg-indigo-600 text-gray-100 rounded-bl-3xl rounded-t-3xl text-start
                        }`}
													>
														<p
															style={{
																margin: 0,
																color: "#d1cfff", // lighter shade for review text
																fontSize: "14px",
															}}
														>
															{reviewText}
														</p>

														<p
															style={{
																marginTop: "12px",
																fontWeight: "500",
																color: "#ffffff",
																fontSize: "15px",
															}}
														>
															{replyText}
														</p>
													</div>
												</>
											);
										})()}
									{message.messageType !== "Request" && (
										<div className="text-gray-500 text-xs text-[0.75em]">
											{new Date(message.createdAt).toLocaleTimeString([], {
												hour: "2-digit",
												minute: "2-digit",
												year: "numeric",
												day: "2-digit",
												month: "2-digit",
											})}
										</div>
									)}
								</li>
							))}
						</ul>
					)}
				</div>

				<hr className="border-gray-200" />

				{guest.dndmode ? (
					<div className="px-4 py-3 bg-yellow-300 text-yellow-800 text-sm border-t border-yellow-300 rounded-b-xl flex items-center justify-center">
						<span>
							Guest unsubscribed. Until guest sends <b>“START”</b>, you cannot
							send messages.
						</span>
					</div>
				) : (
					<div className="flex items-center justify-between px-4 py-3 bg-white border-t border-gray-200 rounded-b-xl">
						<Input
							type="text"
							className="flex-grow px-4 py-2 text-sm border-0 border-gray-300 rounded-xl "
							placeholder="Type your message..."
							value={newMessage}
							onChange={(e) => setNewMessage(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();
									handleSendMessage();
								}
							}}
						/>
						<button
							type="submit"
							className="ml-3 flex items-center justify-center bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl p-3 focus:outline-none focus:ring-2 focus:ring-indigo-300"
							onClick={handleSendMessage}
						>
							{isSending ? (
								<MdOutlineScheduleSend size={20} />
							) : (
								<AiOutlineSend size={20} />
							)}
						</button>
					</div>
				)}
			</div>
			<EditGuestModal
				isOpen={isEditGuestModalOpen}
				onClose={() => setIsEditGuestModalOpen(false)}
				guest={guest}
				onSuccess={handleEditGuestSuccess}
			/>
		</div>
	);
};

export default ChatScreenModal;
